export const resources = {
  SelectFormat: '',
  IncludeAudioEffects: '',
  Download: '',
  Cancel: '',
  includeSpeakers: ''
};
